import edjsHTML from 'editorjs-html'

const edjsParser = edjsHTML()

/**
 * @param {string} jsonString
 * @returns {string|Array<string>}
 */
export const parseEditorJsHtml = (jsonString) => {
  if (!jsonString) return []
  try {
    const parsed = JSON.parse(jsonString)
    return edjsParser.parse(parsed)
  } catch {
    console.error('failed to parse editorJS content')
    return []
  }
}
